import { Box, Heading } from '@chakra-ui/react';
import { setAuth, useAppDispatch, useAuth } from 'core';
import { AuthContext } from '../../types';

export interface LoginProviderProps {
  children: JSX.Element;
}

export const LoginProvider = (props: LoginProviderProps) => {
  const { children } = props;
  const dispatch = useAppDispatch();

  let auth = useAuth();

  if (!auth) {
    const sAuth = localStorage.getItem('user');
    if (sAuth) {
      auth = JSON.parse(sAuth) as AuthContext;
      dispatch(setAuth(auth));
      return (
        <Box>
          <Heading size="md">Redirecting...</Heading>
        </Box>
      );
    }
  }
  return children;
};
